<template>
<section class="main-info-section _preview-section">

    <div class="section-inner">

        <!--MainInfo-->
        <div class="main-info-item-wrap">

            <!--セールス募集-->
            <div class="main-info-item _recruiting" v-if="$store.state.register.form.b_sales_recruitment.length > 0"> <!--|| $store.state.register.form.c_sales_recruitment.length > 0-->
                <h2 class="">セールス募集</h2>
                <SvgIconRecruiting />
                <div class="group form_checkbox" v-if="$store.state.register.form.b_sales_recruitment.length > 0">
                    <div class="md_label _center">
                        <span>BtoB</span>
                    </div>
                    <p class="list_square-separate">
                        <span v-for="(b_sales_recruitment,index) in $store.state.register.form.b_sales_recruitment" v-bind:key="index">
                            {{b_sales_recruitment.name}}
                        </span>
                    </p>
                </div>
                <!-- <div class="group form_checkbox" v-if="$store.state.register.form.c_sales_recruitment.length > 0">
                    <div class="md_label _center">
                        <span>BtoC</span>
                    </div>
                    <p class="list_square-separate">
                        <span v-for="(c_sales_recruitment,index) in $store.state.register.form.c_sales_recruitment" v-bind:key="index">
                            {{c_sales_recruitment.name}}
                        </span>
                    </p>
                </div> -->
            </div>

            <!--セールススタイル-->
            <div class="main-info-item _style" v-if="$store.state.register.form.sales_style.length > 0">
                <h2 class="">セールススタイル</h2>
                <SvgIconSales />
                <div class="group form_checkbox">
                    <p class="list_square-separate">
                        <span v-for="(sales_style,index) in $store.state.register.form.sales_style" v-bind:key="index">
                            {{sales_style.name}}
                        </span>
                    </p>
                </div>
            </div>

            <!--卸値-->
            <div class="main-info-item _percent" v-if="$store.state.register.form.rate_dm_form === 0 || $store.state.register.form.rate_dm_form === 1 || $store.state.register.form.rate_dm_form === 2 || $store.state.register.form.rate_dm_form === 3 || $store.state.register.form.rate_dm_form === 4 || $store.state.register.form.rate_dm_form === 5">
                <h2 class="">卸値</h2>
                <SvgIconPercent />
                <div v-if="$store.state.register.form.rate_dm_form == 0" class="detail _percent-select-text _block">
                    <span>AUMAトークでお問い合わせください</span>
                </div>
                <div v-if="$store.state.register.form.rate_dm_form == 1" class="detail _range" :class="classObject">
                    <div v-if="$store.state.register.form.rate_min">
                        {{ $store.state.register.form.rate_min }}<span>%</span>
                    </div>
                    <div v-if="$store.state.register.form.rate_max">
                        {{ $store.state.register.form.rate_max }}<span>%</span>
                    </div>
                </div>
                <div v-if="$store.state.register.form.rate_dm_form == 1" class="detail _percent-notes _block">
                    <span>※取引形態によって異なります。</span>
                </div>

                <!-- AddInput -->
                <div class="price-add-input">

                    <!-- 箱売り -->
                    <div class="row" v-if="$store.state.register.form.rate_dm_form == 2">
                        <div class="export-title">
                            <div class="title"><span>箱 (ケース) 売り</span></div>
                        </div>
                        <div class="export-price">
                            <div class="unit">
                                <div>1個</div>
                            </div>
                            <div class="min"><span>{{ $store.state.register.form.box_price_min }}</span></div>
                            <div class="elm">～</div>
                            <div class="max"><span>{{ $store.state.register.form.box_price_max }}</span></div>
                        </div>
                    </div>

                    <!-- 量り売り -->
                    <div class="row" v-if="$store.state.register.form.rate_dm_form == 3">
                        <div class="export-title">
                            <div class="title"><span>箱 (ケース) 売り</span></div>
                        </div>
                        <div class="export-price">
                            <div class="unit _gramme">
                                <div>1個</div>
                                <div><span>{{ $store.state.register.form.one_gram }}</span></div>
                            </div>
                            <div class="min"><span>{{ $store.state.register.form.gram_price_min }}</span></div>
                            <div class="elm">～</div>
                            <div class="max"><span>{{ $store.state.register.form.gram_price_max }}</span></div>
                        </div>
                    </div>

                    <!-- 最小ロット数 -->
                    <div class="row" v-if="$store.state.register.form.rate_dm_form == 5">
                        <div class="export-title">
                            <div class="title"><span>最小ロット数</span></div>
                        </div>
                        <div class="export-price">
                            <div class="unit _gramme">
                                <div class="lot_free_text">{{ $store.state.register.form.lot_free_text }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- 自由に記載する -->
                    <div class="row" v-if="$store.state.register.form.rate_dm_form == 4">
                        <!-- <div class="export-title">
                            <div class="title"><span>自由に記載する</span></div>
                        </div> -->
                        <div class="export-price">
                            <div class="unit _gramme">
                                <div class="price_free_text">{{ $store.state.register.form.price_free_text }}</div>
                            </div>
                        </div>
                    </div>

                </div><!-- /AddInput -->

            </div><!--/卸値-->

        </div>

    </div>

</section><!--/.page-name-row-->
</template>

<style>
.detail._range._no-tilde::after {
    content: ''
}

.lot_free_text {
    white-space: pre-wrap;
}

.price_free_text {
    white-space: pre-wrap;
}
</style>

<script>
    //Svg
    import SvgIconPercent from '@/components/EndUser/svg/SvgIconPercent'
    import SvgIconSales from '@/components/EndUser/svg/SvgIconSales'
    import SvgIconRecruiting from '@/components/EndUser/svg/SvgIconRecruiting'
    export default {
        components: {
            SvgIconSales,
            SvgIconPercent,
            SvgIconRecruiting
        },
        computed: {
            unitAndBasic() {
                if (this.$store.state.detail.set.unitAndBasic) {
                    return true;
                }
            },
            adminAndBasic() {
                if (this.$store.state.detail.set.adminAndBasic) {
                    return true;
                }
            },
            activeBasicBrand() {
                if (this.$store.state.detail.set.activeBasicBrand) {
                    return true;
                }
            },
            classObject() {
                // rate_minまたはrate_max片方しかない時は「〜」が表示されないクラスにします
                const singleRate = !this.$store.state.register.form.rate_min || !this.$store.state.register.form.rate_max;
                return {
                    '_no-tilde': singleRate
                }
            }

        }
    }
</script>
